import { Col, Container, Row } from "react-bootstrap";

//images
import heroBottomShape from "../../assets/images/hero-bottom-shape.png";
import hero5Img from "../../assets/images/heros/hero-5-img-new.png";

const Hero9 = () => {
  return (
    <>
      <section className="hero-5 bg-light">
        <Container>
          <Row className="justify-content-center text-center hero-content">
            <Col lg={8}>
              <h1 className="hero-title fw-bold mb-4 display-4">
                <span className="text-primary">Market Data Transparency:</span>{" "}
                Your Information Source Details.
              </h1>
            </Col>
          </Row>
        </Container>
        <div className="bottom-shape position-absolute bottom-0 start-0 end-0">
          <img src={heroBottomShape} alt="" className="w-100" />
        </div>
      </section>

      <div className="hero-5-img">
        <Container>
          <Row className="justify-content-center hero-content">
            <Col lg={10}>
              <div className="hero-5-img-content">
                <img
                  src={hero5Img}
                  alt=""
                  className="img-fluid d-block mx-auto"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Hero9;
